export enum CypressToastClassNames {
    Container = "cy-toast-container",
    Toast = "cy-toast",
}

export enum ToastClassNames {
    Container = "orbit-toast-container",
    Toast = "orbit-toast",
    Body = "orbit-toast-body",
    ProgressBar = "orbit-toast-progress-bar"
}

let toastClassNames: string = "";
export function addToastClassName(className?: string | undefined) {
    if (!className) {
        return toastClassNames;
    }
    toastClassNames += " " + className;
    return toastClassNames;
}